export default "__VITE_ASSET__17f4d622__"